<div class="rounded-lg p-6 shadow-sm border bg-blue-50 border-blue-200">
  <div class="flex mb-4">
    <div class="flex flex-col">
      <div class="font-bold rounded-full w-8 h-8 flex items-center justify-center mr-3">
        {{ question.index_number }}
      </div>
    </div>
    <h2 class="text-lg font-semibold">
      {{ question.question }}<span *ngIf="question.is_required" class="text-red-500"> *</span>
    </h2>
  </div>
  <div class="mt-4 px-10">
    <textarea
      [name]="'question_' + question.uuid"
      disabled
      rows="4"
      maxlength="200"
      class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      placeholder="Enter your answer here..."
    ></textarea>
    <p class="text-sm text-gray-500 mt-2 text-right">0/200 characters</p>
  </div>
</div>
